(function () {
  'use strict';

  if (customElements.get('pf-newsletter-signup')) return;

  class PfNewsletterSignup extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.video = this.querySelector('.pf-newsletter-signup__video');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isIntersecting = !('IntersectionObserver' in window);
      this.playGeneration = 0;

      this.onStateChange = this.syncVideo.bind(this);
      this.motionQuery.addEventListener('change', this.onStateChange);
      document.addEventListener('visibilitychange', this.onStateChange, {
        signal: this.abortController.signal
      });

      if (this.video) {
        this.video.muted = true;
        this.video.addEventListener('playing', this.onPlaying.bind(this), {
          signal: this.abortController.signal
        });
        this.video.addEventListener('error', this.onVideoUnavailable.bind(this), {
          signal: this.abortController.signal
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            function (entries) {
              this.isIntersecting = entries.some(function (entry) {
                return entry.isIntersecting && entry.intersectionRatio > 0;
              });
              this.syncVideo();
            }.bind(this),
            { threshold: 0.01 }
          );
          this.observer.observe(this);
        }
      }

      var status = this.querySelector('[data-pf-newsletter-status]');
      if (status) {
        window.requestAnimationFrame(
          function () {
            if (this.getClientRects().length > 0) status.focus();
          }.bind(this)
        );
      }

      this.syncVideo();
    }

    disconnectedCallback() {
      this.playGeneration += 1;
      if (this.observer) this.observer.disconnect();
      if (this.video) this.video.pause();
      if (this.abortController) this.abortController.abort();
      if (this.motionQuery && this.onStateChange) {
        this.motionQuery.removeEventListener('change', this.onStateChange);
      }

      this.classList.remove('is-video-playing');
      this.abortController = null;
      this.observer = null;
      this.video = null;
      this.motionQuery = null;
      this.onStateChange = null;
    }

    onPlaying() {
      if (!this.shouldPlay()) return;
      this.classList.add('is-video-playing');
    }

    onVideoUnavailable() {
      this.classList.remove('is-video-playing');
    }

    shouldPlay() {
      return Boolean(
        this.video &&
        this.isIntersecting &&
        !document.hidden &&
        this.motionQuery &&
        !this.motionQuery.matches
      );
    }

    syncVideo() {
      if (!this.video) return;

      if (!this.shouldPlay()) {
        this.playGeneration += 1;
        this.video.pause();
        this.classList.remove('is-video-playing');
        return;
      }

      if (!this.video.dataset.pfNewsletterLoaded) {
        this.video.dataset.pfNewsletterLoaded = 'true';
        this.video.preload = 'metadata';
        this.video.load();
      }

      if (!this.video.paused) return;

      var generation = ++this.playGeneration;
      this.video.play().then(
        function () {
          if (generation === this.playGeneration && this.shouldPlay()) {
            this.classList.add('is-video-playing');
          }
        }.bind(this)
      ).catch(
        function () {
          if (generation === this.playGeneration) this.onVideoUnavailable();
        }.bind(this)
      );
    }
  }

  customElements.define('pf-newsletter-signup', PfNewsletterSignup);
})();
